module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('div', {
    staticClass: "nav-item hero-brand",
    on: {
      "click": function($event) {
        return _vm.reloadPage()
      }
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("内容标注平台")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dev.isShow),
      expression: "dev.isShow"
    }],
    staticClass: "vue branch-show"
  }, [_vm._v("\n              tagging：" + _vm._s(_vm.dev.tagging) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.user && _vm.user.id),
      expression: "!!user && user.id"
    }],
    staticClass: "nav-item"
  }, [_vm._v("\n          " + _vm._s(_vm.user.name + '（ID:' + _vm.user.id + '）') + "\n        ")]), _vm._v(" "), (!_vm.isLogin) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("登录\n        ")]) : _c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-291a6dd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/Navbar.vue
// module id = 642
// module chunks = 25